module.exports = __webpack_public_path__ + "img/IND-B-2-IV.51874c03.png";